<template>
  <div class="disclaimer-page">
    <div class="container">
      <div class="content-wrapper">
        <div class="sidebar">
          <nav class="toc">
            <h3>{{ getContent('tableOfContents') }}</h3>
            <ul>
              <li v-for="(section, index) in disclaimerContent" :key="index">
                <a :href="`#section-${index}`" @click.prevent="scrollToSection(index)">
                  {{ section.title }}
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div class="main-content">
          <header class="page-header">
            <h1>{{ getContent('disclaimer') }}</h1>
            <!-- <p class="last-updated">{{ getContent('lastUpdated') }}: {{ lastUpdated }}</p> -->
          </header>

          <div class="document-content">
            <section v-for="(section, index) in disclaimerContent" :key="index" :id="`section-${index}`" class="document-section">
              <h2>{{ section.title }}</h2>
              <div v-for="(content, contentIndex) in section.content" :key="contentIndex">
                <h3 v-if="content.subtitle">{{ content.subtitle }}</h3>
                <p v-for="(paragraph, pIndex) in content.paragraphs" :key="pIndex">
                  {{ paragraph }}
                </p>
              </div>
            </section>
          </div>

          <!-- <footer class="document-footer">
            <p>{{ getContent('documentFooter') }}</p>
          </footer> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted } from 'vue'

  // 语言状态
  const { t, locale } = useI18n()

  // 静态文案数据
  const contentData = {
    zh: {
      pageTitle: '免责声明 - 三福',
      pageDescription: '三福网站免责声明',
      home: '首页',
      disclaimer: '免责声明',
      tableOfContents: '目录',
      lastUpdated: '最后更新',
      lastUpdatedDate: '2025年1月15日',
      documentFooter: '本文件为正式法律文件，请仔细阅读',
      disclaimerContent: [
        {
          title: '一、声明适用范围',
          content: [
            {
              paragraphs: ['本免责声明适用于所有访问、使用本网站的用户，无论您是普通浏览者、注册会员，还是与本网站有业务往来的合作方。当您访问本网站，或使用本网站提供的任何服务、信息时，即视为您已阅读、理解并同意接受本免责声明的全部内容。若您不同意本免责声明的任何条款，请立即停止使用本网站。']
            }
          ]
        },
        {
          title: '二、网站信息说明',
          content: [
            {
              subtitle: '（一）信息准确性',
              paragraphs: ['本网站致力于为用户提供准确、可靠的信息，涵盖品牌介绍、商品展示、合作信息等各方面内容。我们在信息发布前，会对其进行多轮审核与校对，力求保证信息的质量。但由于信息来源广泛、数据更新频繁以及人为操作等不可避免的因素，我们无法保证网站上所有信息绝对准确无误。对于因信息错误、遗漏或偏差给您造成的任何直接或间接损失，包括但不限于决策失误、经济损失、时间浪费等，本网站不承担任何法律责任。', '例如，商品介绍中的颜色、尺寸、材质等细节信息，可能因拍摄光线、显示器差异或供应商提供的数据偏差而与实际商品存在一定出入；品牌动态中的活动时间、地点、规则等信息，也可能因临时调整而未能及时在网站上更新。若您对网站上的信息有任何疑问或需要进一步核实，请随时通过网站提供的联系方式与我们沟通，我们将尽力为您解答和处理。']
            },
            {
              subtitle: '（二）信息时效性',
              paragraphs: ['网站上的信息会根据实际情况进行更新，但由于互联网环境的复杂性和信息变化的快速性，信息可能存在一定的滞后性。部分信息，如商品促销活动、品牌新闻等，具有较强的时效性，其内容和有效性会随着时间的推移而发生变化。因此，用户在依据网站信息做出决策，如采购商品、寻求合作、应聘职位等时，不应仅仅依赖网站内容，还应结合实际情况进行综合判断，必要时可与相关方进行进一步的沟通确认。本网站对因信息时效性问题导致的任何后果不承担责任。']
            }
          ]
        },
        {
          title: '三、商品相关声明',
          content: [
            {
              paragraphs: ['本网站上展示的各类商品的描述信息，包括但不限于颜色、尺寸、材质、功能、使用方法等，均是我们根据产品资料和实际情况精心编写，力求为用户呈现最准确、全面的商品细节。然而，由于商品生产批次不同、拍摄光线角度差异、显示器色彩校准偏差以及供应商提供信息更新不及时等因素，商品实际情况可能与网站描述存在细微差别。例如，服装的实际颜色可能因不同显示器的显示效果而有所不同；玩具的某些小部件尺寸可能在生产过程中存在极小的公差范围。所以，商品的实际情况请以实物为准。若您对商品描述有任何疑问，欢迎随时联系我们的客服团队，我们将竭诚为您服务。']
            }
          ]
        },
        {
          title: '四、第三方链接声明',
          content: [
            {
              paragraphs: ['为了给您提供更丰富的信息和便捷的服务，本网站可能会包含指向第三方网站的链接。这些链接仅为方便您的浏览和获取更多相关信息而提供，并不代表我们对第三方网站的认可、推荐或与第三方存在任何合作关系。我们对第三方网站的内容、服务、隐私政策、安全性以及准确性等方面均不承担任何责任。第三方网站可能有其独立的隐私政策和使用条款，与本网站的规定有所不同。当您点击第三方链接时，您将离开本网站并进入第三方网站，其运作和内容均由该第三方负责。在访问第三方网站时，请您谨慎仔细阅读其相关条款和政策，判断并承担可能存在的风险。']
            }
          ]
        },
        {
          title: '五、用户行为责任',
          content: [
            {
              paragraphs: [
                '用户在使用本网站时，应严格遵守中华人民共和国的相关法律法规，包括但不限于《中华人民共和国网络安全法》《中华人民共和国电子商务法》《互联网信息服务管理办法》等，不得利用本网站从事任何违法违规活动。同时，用户应遵守社会公德和公序良俗，不得通过篡改、虚构或其他利用方式使用本网站所提供信息后发布任何违法、违规、有害、淫秽、色情、暴力、恐怖、煽动性、侵犯他人权益或违背道德伦理的信息，如涉及宣扬恐怖主义、极端主义的文字、图片、音视频，以及传播淫秽色情的图片、视频等内容。',
                '用户需对自身在本网站的一切行为负责，包括但不限于注册信息的真实性、发布内容的合法性、与其他用户的互动行为等。若用户的行为违反法律法规或本声明的规定，导致本网站或任何第三方遭受损失、索赔、诉讼、行政处罚或其他法律责任，用户应承担全部赔偿责任，并使本网站免受损害。',
                '此外，用户不得利用本网站进行任何可能干扰网站正常运行、破坏网站安全、侵犯网站知识产权或其他用户合法权益的操作，如恶意攻击网站服务器、进行网络诈骗、侵犯他人知识产权等。若发现用户存在上述违规行为，本网站有权采取相应措施，包括但不限于警告、限制用户账号功能、冻结或注销用户账号、删除违规内容等。对于情节严重或构成犯罪的行为，本网站将依法移送司法机关处理。'
              ]
            }
          ]
        },
        {
          title: '六、不可抗力免责',
          content: [
            {
              paragraphs: ['由于不可抗力事件导致的本网站无法正常运行、信息错误、服务中断或其他相关问题，本网站运营者不承担任何法律责任。不可抗力是指不能预见、不能避免并不能克服的客观情况，包括但不限于自然灾害（如地震、洪水、台风、火灾等）、政府行为（如法律法规的变更、行政命令、政策调整等）、社会异常事件（如战争、罢工、骚乱等）、网络故障（如黑客攻击、网络拥堵、服务器故障、电信运营商线路中断等）。']
            }
          ]
        },
        {
          title: '七、法律适用与争议解决',
          content: [
            {
              subtitle: '（一）法律适用',
              paragraphs: ['本声明的订立、生效、履行、解释及争议解决，均适用《中华人民共和国民法典》《中华人民共和国电子商务法》等中华人民共和国法律法规（不包括冲突法规则）。']
            },
            {
              subtitle: '（二）争议解决',
              paragraphs: ['若您与本网站就本声明内容或使用本网站过程中发生任何争议，应首先通过友好协商解决；协商不成的，任何一方均有权向本网站运营主体（三福服饰有限公司）所在地有管辖权的人民法院提起诉讼。']
            }
          ]
        },
        {
          title: '八、声明变更',
          content: [
            {
              paragraphs: ['本网站有权根据法律法规更新、业务调整或运营需要，随时修改本声明内容。修改后的声明将在本网站 "法律声明" 模块以显著方式公示，公示之日起即生效。若您在声明修改后继续使用本网站，视为您已接受修改后的声明内容；若您不同意修改后的声明，应立即停止使用本网站。建议您定期查看本声明，了解最新内容。']
            }
          ]
        },
        {
          title: '九、声明结尾',
          content: [
            {
              paragraphs: ['生效时间：本免责声明自 2025年 12月 1日起正式生效，替代此前发布的所有相关免责声明。', '联系方式：若您对本声明有任何疑问或需要协助，可通过以下方式联系我们：', '官方客服电话：400-111-1992', 
              // '官方邮箱：sanfubrand@163.com', 
              '联系地址：中国福建省福州市鼓楼区省府路1号省府大院金皇大厦9楼西0901', '解释权归属：本声明的最终解释权归本网站运营主体 三福服饰有限公司 所有，除法律另有强制性规定外，任何未尽事宜均由本公司根据合理原则进行补充说明。']
            }
          ]
        }
      ]
    },
    en: {
      pageTitle: 'Disclaimer - Sanfu',
      pageDescription: 'Sanfu website disclaimer',
      home: 'Home',
      disclaimer: 'Disclaimer',
      tableOfContents: 'Table of Contents',
      lastUpdated: 'Last Updated',
      lastUpdatedDate: 'January 15, 2025',
      documentFooter: 'This is an official legal document, please read carefully',
      disclaimerContent: [
        {
          title: '1. Scope of Application',
          content: [
            {
              paragraphs: ['This disclaimer applies to all users who access and use this website, whether you are a regular visitor, registered member, or business partner with the website. By accessing this website or using any services or information provided by this website, you are deemed to have read, understood and agreed to accept all contents of this disclaimer. If you do not agree to any terms of this disclaimer, please stop using this website immediately.']
            }
          ]
        },
        {
          title: '2. Website Information Statement',
          content: [
            {
              subtitle: '(1) Information Accuracy',
              paragraphs: [
                'This website is committed to providing users with accurate and reliable information, covering all aspects of brand introduction, product display, and cooperation information. We conduct multiple rounds of review and proofreading before publishing information to ensure quality. However, due to unavoidable factors such as extensive information sources, frequent data updates, and human operations, we cannot guarantee that all information on the website is absolutely accurate. The website shall not be liable for any direct or indirect losses caused by information errors, omissions or deviations, including but not limited to decision-making errors, economic losses, time waste, etc.',
                'For example, the color, size, material and other details in the product introduction may have some differences from the actual product due to shooting light, display differences or data deviations provided by suppliers; the activity time, location, rules and other information in brand dynamics may not be updated in time on the website due to temporary adjustments. If you have any questions about the information on the website or need further verification, please feel free to contact us through the contact information provided by the website, and we will do our best to answer and handle it for you.'
              ]
            },
            {
              subtitle: '(2) Information Timeliness',
              paragraphs: ['The information on the website will be updated according to the actual situation, but due to the complexity of the Internet environment and the rapidity of information changes, the information may have certain lags. Some information, such as product promotions and brand news, has strong timeliness, and its content and validity will change over time. Therefore, when users make decisions based on website information, such as purchasing products, seeking cooperation, or applying for jobs, they should not rely solely on website content, but should make comprehensive judgments based on actual conditions, and communicate with relevant parties for further confirmation when necessary. This website is not responsible for any consequences caused by information timeliness issues.']
            }
          ]
        },
        {
          title: '3. Product Related Statement',
          content: [
            {
              paragraphs: [
                'The description information of various products displayed on this website, including but not limited to color, size, material, function, usage, etc., is carefully compiled by us based on product materials and actual conditions, striving to present the most accurate and comprehensive product details to users. However, due to different product production batches, shooting light angle differences, display color calibration deviations, and untimely updates of information provided by suppliers, the actual situation of products may have subtle differences from the website description. For example, the actual color of clothing may be different due to the display effect of different displays; the size of some small parts of toys may have a minimal tolerance range during the production process. Therefore, please refer to the actual product for the actual situation of the product. If you have any questions about the product description, please feel free to contact our customer service team, and we will serve you wholeheartedly.'
              ]
            }
          ]
        },
        {
          title: '4. Third-Party Link Statement',
          content: [
            {
              paragraphs: ['In order to provide you with richer information and convenient services, this website may contain links to third-party websites. These links are provided only for your convenience in browsing and obtaining more relevant information, and do not represent our endorsement, recommendation of third-party websites or any cooperative relationship with third parties. We are not responsible for the content, services, privacy policies, security, and accuracy of third-party websites. Third-party websites may have independent privacy policies and terms of use that differ from those of this website. When you click on a third-party link, you will leave this website and enter a third-party website, whose operation and content are solely the responsibility of that third party. When visiting third-party websites, please carefully read their relevant terms and policies, judge and bear possible risks.']
            }
          ]
        },
        {
          title: '5. User Behavior Responsibility',
          content: [
            {
              paragraphs: [
                'Users should strictly abide by the relevant laws and regulations of the People\'s Republic of China when using this website, including but not limited to the "Cybersecurity Law of the People\'s Republic of China", the "E-Commerce Law of the People\'s Republic of China", and the "Internet Information Service Management Measures", and shall not use this website to engage in any illegal or irregular activities. At the same time, users should abide by social ethics and public order and morals, and shall not publish any illegal, irregular, harmful, obscene, pornographic, violent, terrorist, inciting, infringing on the rights and interests of others or violating ethical ethics information through tampering, fabricating or other means of using the information provided by this website, such as texts, pictures, audio and video involving the promotion of terrorism and extremism, and the dissemination of obscene and pornographic pictures and videos.',
                "Users shall be responsible for all their behaviors on this website, including but not limited to the authenticity of registration information, the legality of published content, and interactive behaviors with other users. If a user's behavior violates laws and regulations or the provisions of this statement, causing losses, claims, lawsuits, administrative penalties or other legal responsibilities to this website or any third party, the user shall bear all compensation responsibilities and indemnify this website from damage.",
                'In addition, users shall not use this website to perform any operations that may interfere with the normal operation of the website, destroy website security, infringe upon the intellectual property rights of the website or the legitimate rights and interests of other users, such as maliciously attacking website servers, conducting online fraud, and infringing upon the intellectual property rights of others. If it is found that users have the above-mentioned violations, this website has the right to take corresponding measures, including but not limited to warnings, restricting user account functions, freezing or canceling user accounts, and deleting violation content. For serious cases or criminal acts, this website will be transferred to judicial authorities for handling in accordance with the law.'
              ]
            }
          ]
        },
        {
          title: '6. Force Majeure Disclaimer',
          content: [
            {
              paragraphs: ["The website operator shall not be liable for any legal liability due to the website's inability to operate normally, information errors, service interruptions or other related issues caused by force majeure events. Force majeure refers to objective circumstances that cannot be foreseen, avoided or overcome, including but not limited to natural disasters (such as earthquakes, floods, typhoons, fires, etc.), government actions (such as changes in laws and regulations, administrative orders, policy adjustments, etc.), social abnormal events (such as wars, strikes, riots, etc.), network failures (such as hacker attacks, network congestion, server failures, telecom operator line interruptions, etc.)."]
            }
          ]
        },
        {
          title: '7. Applicable Law and Dispute Resolution',
          content: [
            {
              subtitle: '(1) Applicable Law',
              paragraphs: ['The formulation, effectiveness, performance, interpretation and dispute resolution of this statement shall be governed by the laws and regulations of the People\'s Republic of China, including the "Civil Code of the People\'s Republic of China" and the "E-Commerce Law of the People\'s Republic of China" (excluding conflict of laws rules).']
            },
            {
              subtitle: '(2) Dispute Resolution',
              paragraphs: ["If any disputes arise between you and this website regarding the content of this statement or the use of this website, they should first be resolved through friendly consultation; if the consultation fails, either party has the right to file a lawsuit with the people's court with jurisdiction in the location of the website operator (Sanfu Apparel Co., Ltd.)."]
            }
          ]
        },
        {
          title: '8. Statement Changes',
          content: [
            {
              paragraphs: ['This website has the right to modify the content of this statement at any time according to updates of laws and regulations, business adjustments or operational needs. The revised statement will be prominently displayed in the "Legal Statement" module of this website, and will take effect from the date of announcement. If you continue to use this website after the statement is modified, it will be deemed that you have accepted the revised statement content; if you do not agree to the revised statement, you should stop using this website immediately. It is recommended that you check this statement regularly to understand the latest content.']
            }
          ]
        },
        {
          title: '9. Statement Conclusion',
          content: [
            {
              paragraphs: ['Effective Date: This disclaimer will officially take effect on December 1, 2025, replacing all previously issued related disclaimers.', 'Contact Information: If you have any questions about this statement or need assistance, you can contact us through the following methods: ', 'Official Customer Service Phone: +86 400-111-1992', 
              // '  Official Email: sanfubrand@163.com ',
               ' Address: 0901 West, 9th Floor, Jinhuang Building, Provincial Government Courtyard, No.1 Shengfu Road, Gulou District, Fuzhou City, Fujian Province, China', 'Right of Interpretation: The final right of interpretation of this statement belongs to the website operator Sanfu Apparel Co., Ltd. Unless otherwise stipulated by law, any matters not covered herein will be supplemented by the company according to reasonable principles.']
            }
          ]
        }
      ]
    },
    id: {
      pageTitle: 'Disclaimer - Sanfu',
      pageDescription: 'Sanfu website disclaimer',
      home: 'Beranda',
      disclaimer: 'Disclaimer',
      tableOfContents: 'Daftar Isi',
      lastUpdated: 'Terakhir Diperbarui',
      lastUpdatedDate: '15 Januari 2025',
      documentFooter: 'Ini adalah dokumen hukum resmi, harap baca dengan cermat',
      disclaimerContent: [
        {
          title: '1. Ruang Lingkup Pernyataan',
          content: [
            {
              paragraphs: ['Penafian ini berlaku untuk semua pengguna yang mengakses dan menggunakan situs web ini, baik Anda pengunjung biasa, anggota terdaftar, atau mitra bisnis dengan situs web ini. Dengan mengakses situs web ini atau menggunakan layanan atau informasi apa pun yang disediakan oleh situs web ini, Anda dianggap telah membaca, memahami dan menyetujui untuk menerima seluruh isi penafian ini. Jika Anda tidak setuju dengan ketentuan apa pun dari penafian ini, harap hentikan penggunaan situs web ini segera.']
            }
          ]
        },
        {
          title: '2. Pernyataan Informasi Situs Web',
          content: [
            {
              subtitle: '(1) Akurasi Informasi',
              paragraphs: [
                'Situs web ini berkomitmen untuk menyediakan pengguna dengan informasi yang akurat dan dapat diandalkan, mencakup semua aspek perkenalan merek, tampilan produk, dan informasi kerjasama. Kami melakukan beberapa putaran peninjauan dan pemeriksaan sebelum mempublikasikan informasi untuk memastikan kualitasnya. Namun, karena faktor-faktor yang tidak dapat dihindari seperti sumber informasi yang luas, pembaruan data yang sering, dan operasi manusia, kami tidak dapat menjamin bahwa semua informasi di situs web ini benar-benar akurat. Situs web tidak bertanggung jawab atas kerugian langsung atau tidak langsung yang disebabkan oleh kesalahan, kelalaian, atau penyimpangan informasi, termasuk namun tidak terbatas pada kesalahan pengambilan keputusan, kerugian ekonomi, pemborosan waktu, dll.',
                'Misalnya, warna, ukuran, bahan dan detail lainnya dalam perkenalan produk mungkin memiliki perbedaan dengan produk aktual karena cahaya pemotretan, perbedaan tampilan, atau penyimpangan data yang disediakan oleh pemasok; informasi waktu kegiatan, lokasi, aturan dan lainnya dalam dinamika merek juga mungkin tidak diperbarui tepat waktu di situs web karena penyesuaian sementara. Jika Anda memiliki pertanyaan tentang informasi di situs web atau perlu verifikasi lebih lanjut, silakan hubungi kami melalui informasi kontak yang disediakan oleh situs web, dan kami akan melakukan yang terbaik untuk menjawab dan menangani untuk Anda.'
              ]
            },
            {
              subtitle: '(2) Kebaruan Informasi',
              paragraphs: ['Informasi di situs web akan diperbarui sesuai dengan situasi aktual, tetapi karena kompleksitas lingkungan internet dan kecepatan perubahan informasi, informasi mungkin memiliki keterlambatan tertentu. Beberapa informasi, seperti promosi produk dan berita merek, memiliki kebaruan yang kuat, dan konten serta validitasnya akan berubah seiring waktu. Oleh karena itu, ketika pengguna membuat keputusan berdasarkan informasi situs web, seperti membeli produk, mencari kerjasama, atau melamar pekerjaan, mereka tidak boleh hanya mengandalkan konten situs web, tetapi harus membuat penilaian komprehensif berdasarkan kondisi aktual, dan berkomunikasi dengan pihak terkait untuk konfirmasi lebih lanjut bila perlu. Situs web ini tidak bertanggung jawab atas konsekuensi apa pun yang disebabkan oleh masalah kebaruan informasi.']
            }
          ]
        },
        {
          title: '3. Pernyataan Terkait Produk',
          content: [
            {
              paragraphs: [
                'Informasi deskripsi berbagai produk yang ditampilkan di situs web ini, termasuk namun tidak terbatas pada warna, ukuran, bahan, fungsi, cara penggunaan, dll., disusun dengan cermat oleh kami berdasarkan materi produk dan kondisi aktual, berusaha menyajikan detail produk yang paling akurat dan komprehensif kepada pengguna. Namun, karena batch produksi produk yang berbeda, perbedaan sudut cahaya pemotretan, penyimpangan kalibrasi warna tampilan, dan pembaruan informasi yang tidak tepat waktu yang disediakan oleh pemasok, situasi aktual produk mungkin memiliki perbedaan kecil dari deskripsi situs web. Misalnya, warna aktual pakaian mungkin berbeda karena efek tampilan layar yang berbeda; ukuran beberapa bagian kecil mainan mungkin memiliki rentang toleransi minimal selama proses produksi. Oleh karena itu, silakan merujuk pada produk aktual untuk situasi aktual produk. Jika Anda memiliki pertanyaan tentang deskripsi produk, silakan hubungi tim layanan pelanggan kami, dan kami akan melayani Anda dengan sepenuh hati.'
              ]
            }
          ]
        },
        {
          title: '4. Pernyataan Tautan Pihak Ketiga',
          content: [
            {
              paragraphs: ['Untuk menyediakan Anda dengan informasi dan layanan yang lebih kaya dan nyaman, situs web ini mungkin berisi tautan ke situs web pihak ketiga. Tautan-tautan ini hanya disediakan untuk kenyamanan penjelajahan Anda dan memperoleh informasi lebih lanjut, dan tidak mewakili dukungan, rekomendasi situs web pihak ketiga atau hubungan kerjasama apa pun dengan pihak ketiga. Kami tidak bertanggung jawab atas konten, layanan, kebijakan privasi, keamanan, dan akurasi situs web pihak ketiga. Situs web pihak ketiga mungkin memiliki kebijakan privasi dan syarat penggunaan independen yang berbeda dari situs web ini. Ketika Anda mengklik tautan pihak ketiga, Anda akan meninggalkan situs web ini dan memasuki situs web pihak ketiga, yang operasi dan kontennya sepenuhnya merupakan tanggung jawab pihak ketiga tersebut. Saat mengunjungi situs web pihak ketiga, harap baca ketentuan dan kebijakan terkait mereka dengan cermat, menilai dan menanggung risiko yang mungkin ada.']
            }
          ]
        },
        {
          title: '5. Tanggung Jawab Perilaku Pengguna',
          content: [
            {
              paragraphs: [
                'Pengguna harus mematuhi ketentuan hukum dan peraturan Republik Rakyat Tiongkok yang relevan saat menggunakan situs web ini, termasuk namun tidak terbatas pada "Undang-Undang Keamanan Siber Republik Rakyat Tiongkok", "Undang-Undang E-Commerce Republik Rakyat Tiongkok", dan "Peraturan Manajemen Layanan Informasi Internet", dan tidak boleh menggunakan situs web ini untuk terlibat dalam aktivitas ilegal atau tidak sesuai peraturan apa pun. Pada saat yang sama, pengguna harus mematuhi etika sosial dan norma umum, dan tidak boleh mempublikasikan informasi ilegal, tidak sesuai peraturan, berbahaya, cabul, pornografi, kekerasan, teror, provokatif, melanggar hak dan kepentingan orang lain atau melanggar etika moral, seperti teks, gambar, audio dan video yang melibatkan promosi terorisme dan ekstremisme, serta penyebaran gambar dan video cabul pornografi, dengan cara mengubah, memalsukan atau menggunakan informasi yang disediakan oleh situs web ini.',
                'Pengguna harus bertanggung jawab atas semua perilaku mereka di situs web ini, termasuk namun tidak terbatas pada keaslian informasi pendaftaran, legalitas konten yang dipublikasikan, dan perilaku interaktif dengan pengguna lain. Jika perilaku pengguna melanggar hukum dan peraturan atau ketentuan pernyataan ini, menyebabkan kerugian, klaim, gugatan, sanksi administratif atau tanggung jawab hukum lainnya kepada situs web ini atau pihak ketiga mana pun, pengguna harus menanggung semua tanggung jawab kompensasi dan mengganti situs web ini dari kerugian.',
                'Selain itu, pengguna tidak boleh menggunakan situs web ini untuk melakukan operasi apa pun yang mungkin mengganggu operasi normal situs web, merusak keamanan situs web, melanggar hak kekayaan intelektual situs web atau hak dan kepentingan sah pengguna lainnya, seperti menyerang server situs web secara berbahaya, melakukan penipuan online, dan melanggar hak kekayaan intelektual orang lain. Jika ditemukan bahwa pengguna memiliki pelanggaran di atas, situs web ini berhak mengambil langkah-langkah yang sesuai, termasuk namun tidak terbatas pada peringatan, membatasi fungsi akun pengguna, membekukan atau membatalkan akun pengguna, dan menghapus konten pelanggaran. Untuk kasus yang parah atau merupakan tindak pidana, situs web ini akan diserahkan kepada otoritas yudisial untuk penanganan sesuai hukum.'
              ]
            }
          ]
        },
        {
          title: '6. Penafian Keadaan Kahar',
          content: [
            {
              paragraphs: ['Operator situs web tidak bertanggung jawab atas tanggung jawab hukum apa pun karena situs web tidak dapat beroperasi secara normal, kesalahan informasi, gangguan layanan atau masalah terkait lainnya yang disebabkan oleh peristiwa keadaan kahar. Keadaan kahar mengacu pada situasi objektif yang tidak dapat diperkirakan, dihindari atau diatasi, termasuk namun tidak terbatas pada bencana alam (seperti gempa bumi, banjir, topan, kebakaran, dll.), tindakan pemerintah (seperti perubahan undang-undang dan peraturan, perintah administratif, penyesuaian kebijakan, dll.), peristiwa abnormal sosial (seperti perang, mogok kerja, kerusuhan, dll.), kegagalan jaringan (seperti serangan peretas, kemacetan jaringan, kegagalan server, pemutusan jalur operator telekomunikasi, dll.).']
            }
          ]
        },
        {
          title: '7. Hukum yang Berlaku dan Penyelesaian Sengketa',
          content: [
            {
              subtitle: '(1) Hukum yang Berlaku',
              paragraphs: ['Penyusunan, efektivitas, pelaksanaan, interpretasi dan penyelesaian sengketa pernyataan ini akan diatur oleh undang-undang dan peraturan Republik Rakyat Tiongkok, termasuk "Kode Sipil Republik Rakyat Tiongkok" dan "Undang-Undang E-Commerce Republik Rakyat Tiongkok" (tidak termasuk aturan konflik hukum).']
            },
            {
              subtitle: '(2) Penyelesaian Sengketa',
              paragraphs: ['Jika terjadi sengketa antara Anda dan situs web ini mengenai isi pernyataan ini atau penggunaan situs web ini, hal tersebut harus diselesaikan terlebih dahulu melalui konsultasi ramah; jika konsultasi gagal, salah satu pihak berhak mengajukan gugatan ke pengadilan rakyat yang memiliki yurisdiksi di lokasi operator situs web (Sanfu Apparel Co., Ltd.).']
            }
          ]
        },
        {
          title: '8. Perubahan Pernyataan',
          content: [
            {
              paragraphs: ['Situs web ini berhak untuk mengubah isi pernyataan ini kapan saja sesuai dengan pembaruan undang-undang dan peraturan, penyesuaian bisnis atau kebutuhan operasional. Pernyataan yang direvisi akan ditampilkan secara menonjol di modul "Pernyataan Hukum" situs web ini, dan akan berlaku sejak tanggal pengumuman. Jika Anda terus menggunakan situs web ini setelah pernyataan direvisi, hal tersebut akan dianggap sebagai penerimaan konten pernyataan yang direvisi; jika Anda tidak setuju dengan pernyataan yang direvisi, Anda harus segera berhenti menggunakan situs web ini. Disarankan untuk memeriksa pernyataan ini secara berkala untuk memahami konten terbaru.']
            }
          ]
        },
        {
          title: '9. Kesimpulan Pernyataan',
          content: [
            {
              paragraphs: ['Tanggal Efektif: Penafian ini akan secara resmi berlaku pada 1 Desember 2025, menggantikan semua penafian terkait yang diterbitkan sebelumnya.', 'Informasi Kontak: Jika Anda memiliki pertanyaan tentang pernyataan ini atau memerlukan bantuan, Anda dapat menghubungi kami melalui cara-cara berikut:', 'Telepon Layanan Pelanggan Resmi: +86 400-111-1992 ',
              //  'Email Resmi: sanfubrand@163.com ', 
              ' Alamat: Jin Huang Building, Lantai 9, No.1, Provincial Road, Distrik Drum, Fuzhou, Provinsi Fujian, Cina, 0901 Barat', 'Hak Interpretasi: Hak interpretasi akhir pernyataan ini dimiliki oleh operator situs web Sanfu Apparel Co., Ltd. Kecuali ditentukan lain oleh hukum, hal-hal yang tidak dicakup di sini akan dilengkapi oleh perusahaan sesuai dengan prinsip-prinsip yang wajar.']
            }
          ]
        }
      ]
    }
  }

  // 获取内容的方法
  const getContent = key => {
    return contentData[locale.value][key] || key
  }

  // 计算属性
  const breadcrumbItems = computed(() => [
    { text: getContent('home'), to: '/' },
    { text: getContent('disclaimer'), to: '/disclaimer' }
  ])

  const lastUpdated = computed(() => getContent('lastUpdatedDate'))

  const disclaimerContent = computed(() => contentData[locale.value].disclaimerContent)

  // 滚动到指定章节
  const scrollToSection = index => {
    const element = document.getElementById(`section-${index}`)
    if (element) {
      const offsetTop = element.offsetTop - 100
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      })
    }
  }

  // 设置页面头部
  useHead({
    title: computed(() => getContent('pageTitle')),
    meta: [
      {
        name: 'description',
        content: computed(() => getContent('pageDescription'))
      }
    ]
  })
</script>

<style scoped lang="less">
  .disclaimer-page {
    padding: 20px 0 60px;
    background-color: #f8f9fa;

    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;

      .content-wrapper {
        display: flex;
        gap: 30px;
        background: #fff;
        padding: 40px;
        border-radius: 12px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        border: 1px solid #f0f0f0;

        .sidebar {
          flex: 0 0 280px;

          .toc {
            position: sticky;
            top: 120px;
            background: #fafbfc;
            border-radius: 8px;
            padding: 20px;
            border: 1px solid #eaeaea;

            h3 {
              font-size: 18px;
              color: #333;
              margin-bottom: 20px;
              padding-bottom: 12px;
              border-bottom: 2px solid #409eff;
              font-weight: 600;
            }

            ul {
              list-style: none;
              padding: 0;
              margin: 0;

              li {
                margin-bottom: 8px;

                a {
                  display: block;
                  padding: 10px 15px;
                  color: #555;
                  text-decoration: none;
                  border-radius: 6px;
                  transition: all 0.3s ease;
                  font-size: 14px;
                  font-weight: 500;
                  border-left: 3px solid transparent;

                  &:hover {
                    background-color: #f0f7ff;
                    color: #409eff;
                    border-left-color: #409eff;
                    transform: translateX(5px);
                  }

                  &:active {
                    background-color: #e6f3ff;
                  }
                }
              }
            }
          }
        }

        .main-content {
          flex: 1;
          min-width: 0;

          .page-header {
            margin-bottom: 40px;
            padding-bottom: 25px;
            border-bottom: 2px solid #f0f0f0;

            h1 {
              font-size: 36px;
              color: #1a1a1a;
              margin-bottom: 15px;
              font-weight: 700;
              line-height: 1.2;
            }

            .last-updated {
              font-size: 14px;
              color: #888;
              font-style: italic;
            }
          }

          .document-content {
            .document-section {
              margin-bottom: 50px;
              padding-bottom: 35px;
              border-bottom: 1px solid #f5f5f5;
              &:last-of-type {
                border-bottom: none;
                margin-bottom: 0;
                padding-bottom: 0;
              }

              h2 {
                font-size: 28px;
                color: #1a1a1a;
                margin-bottom: 25px;
                padding: 15px 20px;
                border-left: 6px solid #409eff;
                background: linear-gradient(135deg, #f8faff 0%, #f0f7ff 100%);
                border-radius: 0 8px 8px 0;
                font-weight: 600;
                line-height: 1.3;
                position: relative;

                &::before {
                  content: '';
                  position: absolute;
                  left: -6px;
                  top: 0;
                  bottom: 0;
                  width: 3px;
                  background: linear-gradient(to bottom, #409eff, #66b1ff);
                  border-radius: 3px;
                }
              }

              h3 {
                font-size: 20px;
                color: #2d3748;
                margin: 30px 0 20px;
                font-weight: 600;
                padding-left: 15px;
                border-left: 3px solid #67c23a;
                line-height: 1.4;
              }

              p {
                font-size: 16px;
                line-height: 1.8;
                color: #4a5568;
                margin-bottom: 20px;
                text-align: justify;
                padding: 0 5px;

                &:last-child {
                  margin-bottom: 0;
                }
              }

              // 为段落添加首行缩进
              p:not(:first-child) {
                text-indent: 2em;
              }
            }
          }

          .document-footer {
            margin-top: 50px;
            padding-top: 25px;
            border-top: 2px solid #eaeaea;
            text-align: center;
            background: #fafbfc;
            border-radius: 8px;
            padding: 25px;

            p {
              font-size: 14px;
              color: #718096;
              font-style: italic;
              margin: 0;
            }
          }
        }
      }
    }
  }

  // 大屏适配
  @media (max-width: 1200px) {
    .disclaimer-page {
      .container {
        max-width: 100%;
        padding: 0 30px;
      }
    }
  }

  // 平板适配
  @media (max-width: 992px) {
    .disclaimer-page {
      .container {
        .content-wrapper {
          //   flex-direction: column;
          gap: 30px;

          .sidebar {
            flex: none;
            width: 100%;
            flex: 0 0 100px;

            .toc {
              position: static;
              width: 200px;
              padding: 20px 10px;
              ul {
                display: grid;
                gap: 8px;
                grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
                li {
                  margin-bottom: 0;

                  a {
                    padding: 10px 0;
                    text-align: center;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    border-left: none;
                    border-bottom: 2px solid transparent;

                    &:hover {
                      border-left-color: transparent;
                      border-bottom-color: #409eff;
                      transform: translateY(-2px);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  // 移动端适配
  @media (max-width: 768px) {
    .disclaimer-page {
      padding: 15px 0 40px;

      .container {
        padding: 0 20px;

        .content-wrapper {
          padding: 25px;
          .sidebar {
            display: none;
          }
          .main-content {
            .page-header {
              h1 {
                font-size: 28px;
              }
            }

            .document-content {
              .document-section {
                h2 {
                  font-size: 24px;
                  padding: 12px 15px;
                }

                h3 {
                  font-size: 18px;
                }

                p {
                  font-size: 15px;
                  line-height: 1.7;
                }
              }
            }
          }
        }
      }
    }
  }

  // 小屏移动端适配
  @media (max-width: 576px) {
    .disclaimer-page {
      .container {
        padding: 0 15px;

        .content-wrapper {
          padding: 20px;

          .sidebar {
            .toc {
              ul {
                grid-template-columns: 1fr;
                gap: 5px;
              }
            }
          }

          .main-content {
            .page-header {
              h1 {
                font-size: 24px;
              }
            }

            .document-content {
              .document-section {
                margin-bottom: 35px;
                padding-bottom: 25px;

                h2 {
                  font-size: 20px;
                  padding: 10px 12px;
                  border-left-width: 4px;
                }

                h3 {
                  font-size: 17px;
                  margin: 25px 0 15px;
                }

                p {
                  font-size: 14px;
                  line-height: 1.6;
                }
              }
            }

            .document-footer {
              margin-top: 35px;
              padding: 20px;
            }
          }
        }
      }
    }
  }

  // 超小屏适配
  @media (max-width: 400px) {
    .disclaimer-page {
      .container {
        .content-wrapper {
          padding: 15px;

          .main-content {
            .page-header {
              h1 {
                font-size: 22px;
              }
            }

            .document-content {
              .document-section {
                h2 {
                  font-size: 18px;
                }

                h3 {
                  font-size: 16px;
                }
              }
            }
          }
        }
      }
    }
  }

  // 打印样式
  @media print {
    .disclaimer-page {
      background: white !important;
      padding: 0 !important;

      .container {
        max-width: none !important;
        padding: 0 !important;

        .language-switcher {
          display: none !important;
        }

        .content-wrapper {
          box-shadow: none !important;
          border: none !important;
          padding: 0 !important;
          flex-direction: column !important;

          .sidebar {
            display: none !important;
          }

          .main-content {
            .page-header {
              border-bottom: 2px solid #000 !important;
            }

            .document-content {
              .document-section {
                page-break-inside: avoid;

                h2 {
                  background: none !important;
                  border-left: 3px solid #000 !important;
                }
              }
            }
          }
        }
      }
    }
  }

  // 深色模式支持
  @media (prefers-color-scheme: dark) {
    .disclaimer-page {
      background-color: #1a1a1a;

      .container {
        .content-wrapper {
          background: #2d3748;
          border-color: #4a5568;

          .sidebar {
            .toc {
              background: #2d3748;
              border-color: #4a5568;

              h3 {
                color: #e2e8f0;
                border-bottom-color: #409eff;
              }

              ul li a {
                color: #cbd5e0;

                &:hover {
                  background-color: #4a5568;
                  color: #409eff;
                }
              }
            }
          }

          .main-content {
            .page-header {
              border-bottom-color: #4a5568;

              h1 {
                color: #f7fafc;
              }

              .last-updated {
                color: #a0aec0;
              }
            }

            .document-content {
              .document-section {
                border-bottom-color: #4a5568;

                h2 {
                  color: #f7fafc;
                  background: linear-gradient(135deg, #2d3748 0%, #4a5568 100%);
                }

                h3 {
                  color: #e2e8f0;
                  border-left-color: #68d391;
                }

                p {
                  color: #cbd5e0;
                }
              }
            }

            .document-footer {
              background: #2d3748;
              border-top-color: #4a5568;

              p {
                color: #a0aec0;
              }
            }
          }
        }
      }
    }
  }

  // 高对比度模式支持
  @media (prefers-contrast: high) {
    .disclaimer-page {
      .container {
        .content-wrapper {
          border: 2px solid #000;

          .sidebar .toc {
            border: 2px solid #000;
          }

          .main-content {
            .document-content .document-section {
              h2 {
                border-left: 4px solid #000;
                background: #fff;
              }

              h3 {
                border-left: 3px solid #000;
              }
            }
          }
        }
      }
    }
  }

  // 减少动画模式支持
  @media (prefers-reduced-motion: reduce) {
    .disclaimer-page {
      .container {
        .sidebar .toc ul li a {
          transition: none;

          &:hover {
            transform: none;
          }
        }
      }
    }
  }
</style>
